/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading dependencies
 * -----------------------------------------------------------------------------------------------------------
 */
import Vue from 'vue'
import Router from 'vue-router'
import { concat } from 'lodash'
// import Meta from 'vue-meta'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading module routes
 * -----------------------------------------------------------------------------------------------------------
 */
import accountRoutes from '../components/account/routes'
import dashboardRoutes from '../components/dashboard/routes'
import regionRoutes from '../components/region/routes'
import cityRoutes from '../components/city/routes'
import districtRoutes from '../components/district/routes'
import wardRoutes from '../components/ward/routes'
import serviceRoutes from '../components/service/routes'
import carrierRoutes from '../components/carrier/routes'
import pricetableRoutes from '../components/pricetable/routes'
import blockRoutes from '../components/block/routes'
import postOfficesRoutes from '../components/postOffice/routes'
import blogRoutes from '../components/blog/routes'
import categoryRoutes from '../components/category/routes'
import permissionDeniedRoutes from 'components/permissiondenied/routes'
import checkServiceRoutes from 'components/checkservice/routes'
import addressRoutes from 'components/address/routes'
import promotionRoutes from 'components/promotion/routes'
import bankRoutes from 'components/bank/routes'
import settingRoutes from 'components/setting/routes'

Vue.use(Router)
// Vue.use(Meta)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }), // Chuyen trang thi scroll ve top
  routes: concat(
    accountRoutes,
    dashboardRoutes,
    regionRoutes,
    cityRoutes,
    districtRoutes,
    serviceRoutes,
    carrierRoutes,
    pricetableRoutes,
    blockRoutes,
    postOfficesRoutes,
    permissionDeniedRoutes,
    checkServiceRoutes,
    blogRoutes,
    categoryRoutes,
    wardRoutes,
    addressRoutes,
    promotionRoutes,
    bankRoutes,
    settingRoutes
  )
})



// WEBPACK FOOTER //
// ./src/router/index.js